import numeral from 'numeral';
import I18n from '../i18n';

const KB2B = 1024;

function formatValue(value, withoutLabel, withoutDecimals) {
  if (Number(value) === 0) {
    return withoutLabel ? '0' : `0G${I18n.t('unit')}`;
  }
  // given values are in KBytes : convert to Bytes to use numeral
  const bytes = numeral(value * KB2B).format(withoutDecimals ? '0ib' : '0[.]00ib');
  if (withoutLabel) {
    return bytes.replace(/[a-zA-Z]+/, '');
  }
  return bytes.replace(/iB/, I18n.t('unit'));
}

export default formatValue;
